import { render, staticRenderFns } from "./CouponPercentagePreview.vue?vue&type=template&id=3e6c476c&scoped=true&"
import script from "./CouponPercentagePreview.vue?vue&type=script&lang=ts&"
export * from "./CouponPercentagePreview.vue?vue&type=script&lang=ts&"
import style0 from "./CouponPercentagePreview.vue?vue&type=style&index=0&id=3e6c476c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6c476c",
  null
  
)

export default component.exports